import { ImageProps, Slide } from '../types';
import { backgroundCircle } from '@features/powerpoint/images/icons';

export const iconInCircle = (
  iconPath: string,
  options: { x: number; y: number },
  iconOptions: ImageProps = {}
): Required<Pick<Slide, 'images'>> => ({
  images: [
    {
      path: backgroundCircle,
      h: 1.5,
      w: 1.5,
      ...options,
    },
    {
      path: iconPath,
      h: 1.25,
      w: 1.25,
      x: options.x + 0.13,
      y: options.y + 0.13,
      ...iconOptions,
    },
  ],
});
